<template>
  <div>
    <div class="page">
      <!-- 页面头部 -->
      <div class="page_top">
        <div class="page_top_logo">
          <!-- logo -->
          <div class="logo">
            <img src="https://gao-hui.oss-cn-beijing.aliyuncs.com/images/logo.png" alt="" />
            <p class="logo_text">高慧智能</p>
          </div>
          <!-- 导航栏 -->
          <div id="navigationBar" class="navigationBar">
            <p :class="names == 'home' ? 'optFor' : ''" @click="home">首页</p>
            <p :class="names == 'intro' ? 'optFor' : ''" @click="intro">
              企业简介
            </p>
            <p :class="names == 'vision' ? 'optFor' : ''" @click="vision">
              企业愿景
            </p>
            <p
              :class="names == 'businessService' ? 'optFor' : ''"
              @click="businessService"
            >
              业务服务
            </p>
            <p :class="names == 'contactUs' ? 'optFor' : ''" @click="contactUs">
              联系我们
            </p>
          </div>
        </div>
      </div>
      <!-- 轮播图 -->
      <div class="page_swiper"></div>
      <!-- 企业简介 -->
      <div></div>
      <div class="enterprise_profile">
        <div class="enterprise_profile_top">
          <p class="enterprise_profile_title">企业简介</p>
          <div class="adorn"></div>
          <p>Enterprise brief introduction</p>
        </div>
        <div class="enterprise_profile_centent">
          <div class="centent_left">
            <img src="https://gao-hui.oss-cn-beijing.aliyuncs.com/images/qyjj_1661762060.jpg" alt="" />
          </div>
          <div class="centent_right">
            <p class="right_title">西安高慧智能科技有限公司</p>
            <p class="right_cont">
              西安高慧智能科技有限公司，专注于精准医疗和AI制药领域，发力”分子医学高性能计算服务”和”分子医学大数据服务，通过高性能计算服务和人工智能大数据服务，精准提升医疗管理、疾病预防、医学研究、药品研发等的智慧化水平，为国家医学分子中心、地区龙头医院提供一站式大数据平台建设
            </p>
          </div>
        </div>
      </div>
      <!-- 励志成为一只健康医疗大数据中心 -->
      <div class="picture"></div>
      <!-- 业务服务 -->
      <div class="business_service">
        <div class="business_service_title">
          <p>业务服务</p>
          <div class="adorn"></div>
          <p>The enterprise service</p>
        </div>
        <div class="business_service_bottom">
          <div class="business_service_bottom_top">
            <div class="business_service_cont">
              <img src="https://gao-hui.oss-cn-beijing.aliyuncs.com/images/gxnjsfw.png" alt="" />
              <p>高性能计算服务</p>
              <p>实现在最短时间内</p>
              <p>完成最大量的计算任务</p>
            </div>
            <div class="business_service_cont">
              <img src="https://gao-hui.oss-cn-beijing.aliyuncs.com/images/fzyxglpt.png" alt="" />
              <p>分子医学大数据管理平台</p>
              <p>核心是阐明人类疾病在</p>
              <p>分子和细胞水平上的病理、</p>
              <p>生理机制，并将有关成果转化为</p>
              <p>临床预测、诊断、预防和治疗的有效手段</p>
              <p>代表着当代生命科学发展趋势。</p>
            </div>
            <div class="business_service_cont">
              <img src="https://gao-hui.oss-cn-beijing.aliyuncs.com/images/jzyl.png" alt="" />
              <p>精准医疗</p>
              <p>实现医源性损害最小化</p>
              <p>医疗耗费最低化以及</p>
              <p>病患获益最大化</p>
            </div>
            <div class="business_service_cont">
              <img src="https://gao-hui.oss-cn-beijing.aliyuncs.com/images/ai.png" alt="" />
              <p>AI制药</p>
              <p>以医药大数据为学习研究土壤</p>
              <p>运用NLP、CV、知识图谱</p>
              <p>机器学习、深度学习等AI技术</p>
              <p>参与制药过程,以计算、预测、寻找合适的</p>
              <p>新兴的有机物化学反应、潜在药物分子并</p>
              <p>观察药物临床效果的技术手段</p>
            </div>
          </div>
        </div>
        <div class="business_service_two">
          <div class="two_title">
            <p>超算平台</p>
            <p>
              依托国家分子医学超算中心以立足西安、辐射全国、构建国内领先、国际一流的信息化基础设施及
            </p>
            <p>
              公共服务平台为总目标，面向医学科学计算、生物医药、人工智能等重点行业应用领域，随需提供超级云计算服务，
            </p>
            <p>支撑医学研究领域的产业升级与科技创新，助力国家医学科技发展</p>
            <img src="https://gao-hui.oss-cn-beijing.aliyuncs.com/images/cspt_1661762386.jpg" alt="" />
          </div>
        </div>
        <div class="business_service_two">
          <div class="two_title">
            <p>分子医学管理平台</p>
            <p>
              支持分子医学领域相关科研工作的开展、包含有常用的管理功能、分别为动物类、细胞类、
            </p>
            <p>
              人类基本信息数据收集分析、整理、统一管理、采用高效云存储、安全高效保证数据高度安全。
            </p>
            <p>
              可采用通用分析流程直接使用超算平台算力进行科研分析。也可采取自定义流程、自由组合分析流程、满足特定科研需求。
            </p>
            <img src="https://gao-hui.oss-cn-beijing.aliyuncs.com/images/111213123_1661762134.jpg" alt="" />
          </div>
        </div>
      </div>
      <!-- 底部 -->
      <div class="bottomx">
        <div class="bottomx_cont">
          <div class="bottom_left">
            <div class="logos">
              <img src="https://gao-hui.oss-cn-beijing.aliyuncs.com/images/bottomLogo.png" alt="" />
              <p>高慧智能</p>
            </div>
            <div class="phone">
              <img src="https://gao-hui.oss-cn-beijing.aliyuncs.com/images/phone.png" alt="" />
              <p>400-188-1961</p>
            </div>
            <div class="site">
              <img src="https://gao-hui.oss-cn-beijing.aliyuncs.com/images/site.png" alt="" />
              <p>陕西省西安市新城区金花北路恒基碧翠锦华31栋1-1502</p>
            </div>
          </div>
          <div class="bottom_right">
            <div class="right_list">
              <p>关于我们</p>
              <p>关于高慧</p>
              <p>联系我们</p>
            </div>
            <div class="right_list">
              <p>产品与服务</p>
              <p>医疗大数据</p>
              <p>人工智能</p>
            </div>
            <div class="right_listx">
              <p>帮助与支持</p>
              <p>帮助文档</p>
            </div>
          </div>
        </div>
        <div class="bottomx_cont_bottom">
          <p>陕ICP备2022008765号</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      names: "home",
    };
  },
  methods: {
    // 首页
    home() {
      this.names = "home";
      document.documentElement.scrollTop = 0;
      document.title = "西安高慧智能科技有限公司"
    },
    // 企业简介
    intro() {
      this.names = "intro";
      document.documentElement.scrollTop = 672;
      document.title = "企业简介"
    },
    // 企业愿景
    vision() {
      this.names = "vision";
      document.documentElement.scrollTop = 1272;
      document.title = "企业愿景"
    },
    // 业务服务
    businessService() {
      this.names = "businessService";
      document.documentElement.scrollTop = 1835;
      document.title = "业务服务"
    },
    // 联系我们
    contactUs() {
      this.names = "contactUs";
      document.documentElement.scrollTop = 3457;
      document.title = "联系我们"
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // console.log(scrollTop, "滚动距离");
      if (scrollTop > 0) {
        this.names = "home";
        if (scrollTop >= 672) {
          this.names = "intro";
          if (scrollTop >= 1200) {
            this.names = "vision";
            if (scrollTop >= 1800) {
              this.names = "businessService";
              if (scrollTop >= 3000) {
                this.names = "contactUs";
              }
            }
          }
        }
      }
    },
    bis() {
      const isMobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      if (isMobile) {
        const protocol = window.location.protocol
        const hostname = window.location.hostname
        const port = window.location.port
        const href = protocol + "//" + hostname + ":" + port + "/mobile"
        window.location.href = href;
      } else {}
    },
  },
  mounted: function () {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("scroll", this.handleScroll, false); // 监听（绑定）滚轮滚动事件
  },
  created() {
    this.bis();
  },
};
</script>

<style scoped>
.page_top {
  width: 100%;
  height: 80px;
  line-height: 80px;
  /* margin-top: 10px; */
  background-color: #fff;
  top: 0;
  position: sticky;
}
.logo {
  overflow: hidden;
  display: flex;
  margin-left: 89px;
}
.logo img {
  width: 68px;
  height: 73px;
  margin-top: 2px;
  margin-right: 14px;
}
.logo_text {
  font-size: 39px;
  font-family: Alibaba PuHuiTi;
  font-weight: bold;
  color: #2753a2;
}
.page_top_logo {
  /* margin-top: 20px; */
  display: flex;
  justify-content: space-between;
}
.navigationBar {
  display: flex;
  width: 730px;
  justify-content: space-between;
  margin-right: 165px;
  font-size: 18px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  color: #333333;
}
.optFor {
  border-bottom: 4px solid #237ff1;
  border-radius: 1.5px;
  height: 65px;
}
.page_swiper {
  width: 100%;
  height: 650px;
  background-image: url("https://gao-hui.oss-cn-beijing.aliyuncs.com/images/swiper_1661762023.jpg");
  background-size: 100% 100%;
}
.adorn {
  width: 70px;
  height: 4px;
  background-color: #237ff1;
  border-radius: 1.5px;
}
.enterprise_profile_top {
  /* height: 100px; */
  width: 300px;
  margin: 0 auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.enterprise_profile_title {
  font-size: 30px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  color: #333333;
  margin-top: 39px;
  margin-bottom: 6px;
}
.enterprise_profile_top p:nth-child(3) {
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 300;
  color: #666666;
  margin-top: 11px;
}
.enterprise_profile_centent {
  width: 70%;
  /* height: 500px; */
  /* background-color: red; */
  margin: 66px auto;
  display: flex;
  overflow: hidden;
}
.centent_left img {
  width: 544px;
  height: 330px;
}
.centent_right {
  margin-left: 100px;
  width: 350px;
}
.right_title {
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  margin-top: 52px;
}
.right_cont {
  margin-top: 48px;
  /* width: 550px; */
  height: 173px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  /* font-weight: 400; */
  color: #666666;
  /* line-height: 31px; */
}
.picture {
  height: 562px;
  background-image: url("https://gao-hui.oss-cn-beijing.aliyuncs.com/images/lzcw_1661762081.jpg");
  background-size: 100% 100%;
}
.business_service_title {
  width: 300px;
  margin: 0 auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}
.business_service_title p:nth-child(1) {
  font-size: 29px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  color: #333333;
  margin-top: 59px;
  margin-bottom: 7px;
}
.business_service_title p:nth-child(3) {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 300;
  color: #666666;
  margin-top: 18px;
}
.business_service_bottom_top {
  width: 70%;
  margin: 22px auto;
  display: flex;
  justify-content: space-between;
}
.business_service_cont {
  width: 282px;
  height: 406px;
  background: #f5f5f5;
  box-shadow: 10px 12px 6px 0px rgba(14, 5, 11, 0.1);
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
  align-items: center;
}
.business_service_cont img {
  width: 170px;
  height: 157px;
  margin-top: 23px;
}
.business_service_cont p:nth-child(2) {
  margin-top: 30px;
  margin-bottom: 30px;
  font-size: 23px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #333333;
}
.business_service_cont p {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
}
.two_title {
  width: 1200px;
  height: 700px;
  margin: 0 auto;
  border: 1px solid #070707;
  background-color: #fff;
}
.business_service_two {
  margin-top: 107px;
}
.two_title img {
  width: 100%;
  height: 82%;
  /* border: 1px ; */
}
.two_title p:nth-child(1) {
  text-align: center;
  font-size: 22px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #565656;
  margin-top: 20px;
  margin-bottom: 14px;
}
.two_title p {
  text-align: center;
  font-size: 15px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
}
.bottomx {
  margin-top: 10px;
  background-color: #063661;
  height: 220px;
  overflow: hidden;
  /* display: flex; */
}
.bottomx .logos {
  height: 62px;
  line-height: 62px;
  display: flex;
}
.bottomx .logos img {
  width: 57px;
  height: 62px;
}
.bottomx .logos p {
  font-size: 33px;
  font-family: Alibaba PuHuiTi;
  font-weight: bold;
  color: #ffffff;
  margin-left: 20px;
}
.phone {
  display: flex;
  height: 25px;
  /* font-size: 26px; */
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  line-height: 19px;
  margin-top: 14px;
}
.phone img {
  width: 16px;
  height: 16px;
  margin-right: 13px;
}
.site {
  display: flex;
  height: 25px;
  /* font-size: 26px; */
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  line-height: 19px;
  margin-top: 14px;
}
.site img {
  width: 16px;
  height: 16px;
  margin-right: 13px;
}
.bottomx_cont {
  width: 1200px;
  margin: 0 auto;
  margin-top: 31px;
  display: flex;
  margin-bottom: 10px;
  /* justify-content: space-between; */
}
.bottom_right {
  padding-left: 10px;
  border-left: 1px solid #d5d5d5;
  height: 129px;
  display: flex;
  width: 500px;
  justify-content: space-between;
  align-items: center;
}
.bottom_left {
  width: 680px;
}
.right_list p:nth-child(1) {
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  margin-bottom: 22px;
}
.right_list p {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 300;
  color: #ffffff;
}
.right_list p:nth-child(2) {
  margin-bottom: 19px;
}
.right_listx p {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 300;
  color: #ffffff;
}
.right_listx p:nth-child(1) {
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  padding-bottom: 60px;
}
.bottomx_cont_bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.5);
  width: 1200px;
  margin: 0 auto;
}
.bottomx_cont_bottom p {
  margin-top: 5px;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  display: flex;
  justify-content: right;
}
</style>